import {Button} from '@material-ui/core';
import {getNonEmptyStringErrors} from 'Core/models/EmptyString';
import {getPasswordRequirements} from 'Core/models/Password';
import CoreRouteConstants from 'Core/CoreRouteConstants';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Link} from 'react-router-dom';
import {showRequirementErrors} from 'Shared/components/ErrorPopover';
import ValidatableTextField from 'Shared/components/ValidatableTextField';
import 'Users/components/UserRecovery/PasswordReset/PasswordResetForm.sass';
import {changeAnswerOne, changeAnswerTwo, changePassword, updatePassword} from 'Users/ducks/passwordRecovery';
import {IndependentAgentProfile} from 'Users/models/IndependentAgentProfile';
import {PasswordResetForm as PasswordResetFormUnion} from 'Users/models/PasswordResetForm';

type PasswordResetFormProps = {
  agentProfile: IndependentAgentProfile;
  requestKey: string;
  passwordResetForm: PasswordResetFormUnion;
};

const passwordInputProps = {
  type: 'password',
};

const PasswordResetForm = ({agentProfile, requestKey, passwordResetForm}: PasswordResetFormProps) => {
  const dispatch = useDispatch();
  const [showPasswordErrors, setShowPasswordErrors] = useState(false);

  return (
    <form className="password-reset__form">
      {PasswordResetFormUnion.match({
        FailureToUpdate: x => (
          <div className="password-reset-form__error-message">
            {x.errorMessage ? x.errorMessage : 'An unknow error has occurred. Please try again later.'}
          </div>
        ),
        default: () => null,
      })(passwordResetForm)}
      <h1>Reset Password</h1>
      <p>{agentProfile.securityQuestions![0].question}</p>
      <ValidatableTextField
        label="Answer"
        onChange={newAnswer => dispatch(changeAnswerOne(newAnswer, passwordResetForm))}
        errors={getNonEmptyStringErrors(passwordResetForm.answerOne)}
        value={passwordResetForm.answerOne.value}
      />
      <p>{agentProfile.securityQuestions![1].question}</p>
      <ValidatableTextField
        className="password-reset__security-question-answer"
        label="Answer"
        onChange={newAnswer => dispatch(changeAnswerTwo(newAnswer, passwordResetForm))}
        errors={getNonEmptyStringErrors(passwordResetForm.answerTwo)}
        value={passwordResetForm.answerTwo.value}
      />
      <p>New Password</p>
      <ValidatableTextField
        id="new-password-input"
        className="password-reset__new-password-input"
        label="New Password"
        showErrors={showRequirementErrors(showPasswordErrors)}
        errors={getPasswordRequirements(passwordResetForm.password)}
        inputProps={passwordInputProps}
        onChange={passwordLine1 =>
          dispatch(changePassword(passwordLine1, passwordResetForm.password.passwordLine2, passwordResetForm))
        }
        value={passwordResetForm.password.passwordLine1}
      />
      <ValidatableTextField
        id="confirm-password-input"
        className="password-reset__confirm-password-input"
        label="Confirm Password"
        onBlur={() => setShowPasswordErrors(true)}
        showErrors={showRequirementErrors(showPasswordErrors)}
        errors={getPasswordRequirements(passwordResetForm.password)}
        inputProps={passwordInputProps}
        onChange={passwordLine2 =>
          dispatch(changePassword(passwordResetForm.password.passwordLine1, passwordLine2, passwordResetForm))
        }
        value={passwordResetForm.password.passwordLine2}
      />
      <div className="password-reset__actions">
        <Link to={CoreRouteConstants.LOGIN}>
          <Button className="password-reset__cancel-button" variant="contained" color="primary">
            Cancel
          </Button>
        </Link>
        <Button
          id="password-reset-submit-button"
          onClick={() => {
            if (PasswordResetFormUnion.is.Valid(passwordResetForm)) {
              dispatch(updatePassword(agentProfile.userId!, requestKey, agentProfile, passwordResetForm));
            }
          }}
          type="submit"
          variant="contained"
          color="primary"
          disabled={!PasswordResetFormUnion.is.Valid(passwordResetForm)}
        >
          Reset Password
        </Button>
      </div>
    </form>
  );
};

export default PasswordResetForm;
